module.exports = __webpack_public_path__ + "static/media/hbguide-banner-2x.03c0fe7e.jpg";